<template>
  <!-- 面包屑 -->
  <a-breadcrumb>
    <a-breadcrumb-item>自媒体管理</a-breadcrumb-item>
    <a-breadcrumb-item>账号管理</a-breadcrumb-item>
  </a-breadcrumb>
  <!-- 功能条 -->
  <div class="tool-view">
    <a-row class="tool-row">
      <a-col :span="6">
        <a-row>
          <!-- 服务商： -->
          <a-col :span="6" class="tool-title">账号：</a-col>
          <a-col :span="18">
            <a-input v-model:value="nameModel" class="tool-item" placeholder="请输入" />
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <a-row>
          <!-- 操作 -->
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap;">
            <a-button type="primary" @click="touchSearch">查询</a-button>
            <a-button style="margin-left: 16px" @click="touchReset">重置</a-button>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="6">
        <!-- 保留布局结构 -->
      </a-col>
      <a-col :span="6">
        <a-row>
          <!-- 操作 -->
          <a-col :span="6" class="tool-title"></a-col>
          <a-col :span="18" style="white-space: nowrap; text-align: right;">
            <a-button type="primary" @click="touchAdd"><plus-outlined /> 新建账号</a-button>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
  <!-- 列表 -->
  <a-table
    class="table-view"
    :data-source="dataSource"
    :columns="columns"
    :row-key="record => record.id"
    :pagination="pagination"
    :loading="isLoading"
    @change="handleTableChange"
  >
    <!-- 自定义行内容 -->
    <template #bodyCell="{ column, record }">
      <!-- 操作 -->
      <template v-if="column.key === 'created_at'">
        <a-tooltip :title="getFullDateTime(record[column.key])" placement="top">
          <span>{{ getShortDate(record[column.key]) }}</span>
        </a-tooltip>
      </template>
      <!-- 媒体 -->
      <template v-else-if="column.key === 'type'">
        {{ MediaTypes.find(item => item.value === record.type)?.text || '-' }}
      </template>
      <!-- 人群分类 -->
      <template v-else-if="column.key === 'people_type'">
        {{ AudienceTypes.find(item => item.value === record.people_type)?.text || '-' }}
      </template>
      <template v-else-if="column.key === 'operation'">
        <a class="operation-item" @click="touchEdit(record)">编辑</a>
      </template>
      <template v-else>
        {{ record[column.key] || '-' }}
      </template>
    </template>
  </a-table>
  
  <!-- 服务商弹窗 -->
  <Add ref="RefAdd" @success="getList"></Add>
</template>

<script setup>
import { onBeforeMount, reactive, ref } from 'vue'
import { message } from 'ant-design-vue'
// 引入 dayjs 及 扩展函数
import dayjs from 'dayjs'
// 引入公共方法
import Pub from '@/utils/public'
// 引入弹窗组件
import Add from './components-accounts/Add'
import { MediaTypes, AudienceTypes } from '@/utils/constantList'
// 引入 API
import { accountList } from '@/api/admin'

// 弹窗引用
let RefAdd = ref(null)
// 服务商名称
let name = ref(undefined)
let nameModel = ref(undefined)
// 状态（已移除）
// let status = ref(undefined)
// 加载
let isLoading = ref(false)
// 数据源
let dataSource = ref([])
// 分页信息
let pagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  showSizeChanger: true
})
// 列数据源
let columns = ref([
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: '账号名称',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '媒体',
    dataIndex: 'type',
    key: 'type'
  },
  {
    title: '账号语种',
    dataIndex: 'lang_name',
    key: 'lang_name'
  },
  {
    title: '人群分类',
    dataIndex: 'people_type',
    key: 'people_type'
  },
  {
    title: '创建日期',
    dataIndex: 'created_date',
    key: 'created_date'
  },
  {
    title: '运营负责人',
    dataIndex: 'admin_name',
    key: 'admin_name'
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation'
  }
])

onBeforeMount (() => {
  // 初始化获取
  touchSearch()
})

// 分页处理
function handleTableChange (p, filters, sorter) {
  pagination.current = p.current
  pagination.pageSize = p.pageSize
  // 获取列表
  getList()
}

// 查询
function touchSearch () {
  // 调整参数
  name.value = nameModel.value
  pagination.current = 1
  // 获取列表
  getList()
}

// 重置
function touchReset () {
  nameModel.value = undefined
  name.value = undefined
  // 初始化获取
  touchSearch()
}

// 新建
function touchAdd () {
  // 显示新建弹窗
  RefAdd.value.showDrawer()
}

// 编辑
function touchEdit (record) {
  // 显示编辑弹窗，传入记录数据
  RefAdd.value.showDrawer(record)
}

// 获取列表
function getList () {
  isLoading.value = true
  const params = {
    name: name.value,
    page: pagination.current,
    page_size: pagination.pageSize
  }
  // TODO: 替换为实际的API调用
  accountList(params).then(res => {
    isLoading.value = false
    const { code, data } = res
    if (code === 0) {
      dataSource.value = data.data
      pagination.total = data.total
    }
  }).catch(() => {
    isLoading.value = false
  })
}

// 获取短日期格式 (YYYY-MM-DD)
function getShortDate (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD')
}

// 获取完整日期时间格式 (YYYY-MM-DD HH:mm:ss)
function getFullDateTime (dateTime) {
  if (!dateTime) return '-'
  return dayjs(dateTime).format('YYYY-MM-DD HH:mm:ss')
}
</script>

<style scoped>

.tool-row {
  margin-bottom: 16px;
}

.tool-title {
  text-align: right;
}

.tool-item {
  width: 100%;
}

.table-view {
  background: #fff;
  border-radius: 6px;
}

.operation-item {
  color: #1890ff;
  margin-right: 16px;
  cursor: pointer;
}

.operation-item:hover {
  color: #40a9ff;
}
</style>
